import SpinnerIcon from 'assets/img/spinner.svg';
import classNames from 'classnames';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

function Spinner({ size, className }: SpinnerProps) {
  return (
    <div className={classNames('', size === 'sm' && 'w-4', className)}>
      <img className="animate-spin" src={SpinnerIcon} alt="Spinner" />
    </div>
  );
}

export default Spinner;
